import { render, staticRenderFns } from "./VabThemeSetting.vue?vue&type=template&id=2388a99a&scoped=true"
import script from "./VabThemeSetting.vue?vue&type=script&lang=js"
export * from "./VabThemeSetting.vue?vue&type=script&lang=js"
import style0 from "./VabThemeSetting.vue?vue&type=style&index=0&id=2388a99a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388a99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2388a99a')) {
      api.createRecord('2388a99a', component.options)
    } else {
      api.reload('2388a99a', component.options)
    }
    module.hot.accept("./VabThemeSetting.vue?vue&type=template&id=2388a99a&scoped=true", function () {
      api.rerender('2388a99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabTheme/components/VabThemeSetting.vue"
export default component.exports